import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { UserStoreActions } from '@era/stores';
import { Store } from '@ngrx/store';
import { User } from '@rocksoft/security-sdk';
import { UserListItemComponent } from './user-list-item.component';

@Component({
  selector: 'era-security-user-list-item',
  templateUrl: './user-list-item.container.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [UserListItemComponent],
})
export class UserListItemContainerComponent {
  private readonly store = inject(Store);

  public readonly user = input<User>();
  public readonly isEditing = input<boolean>();

  deleteEvent(user: User) {
    this.store.dispatch(UserStoreActions.UserListItemUIActions.userDeleteRequested({ user }));
  }
}
